import { type ActionItem } from 'shared/ui'
import { type TableStore } from 'shared/ui/TableNew/store/tableStore'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import type { IResponseCancelInvite, IResponseResendInvite } from 'entities/Users/api/types'
import { cancelInvite } from 'pages/settings/pages/members/ui/actions/cancelInvite/cancelInvite'
import { resendInvite } from './resendInvites/resendInvite'
import { copyInviteLink } from './copyInviteLink/copyInviteLink'

type BulkActionParams = {
  tableStore: TableStore<RowInvite>
  search: string
  onCancelInvitesSuccess: (response: IResponseCancelInvite) => void
  onResendInvitesSuccess: (response: IResponseResendInvite, count: number) => void
}

export const getPendingMembersBulkActions = (
  entities: IEntitiesStore,
  invites: RowInvite[],
  params: BulkActionParams
): ActionItem[] => {
  const { tableStore, search, onCancelInvitesSuccess, onResendInvitesSuccess } = params

  const bulk = {
    all: tableStore.bulkAllMode,
    search,
    total: tableStore.bulkStore.bulkTotal,
  }

  const handleResendInvites = (response: IResponseResendInvite) => {
    tableStore.resetSelected()
    onResendInvitesSuccess(response, invitesCount)
  }

  const handleCancelInvites = (response: IResponseCancelInvite) => {
    tableStore.resetSelected()
    onCancelInvitesSuccess(response)
  }

  const handleCopyInviteLink = () => {
    tableStore.resetSelected()
  }

  const invitesCount = bulk.all ? bulk.total : invites.length

  const actions = [
    resendInvite(invites, handleResendInvites, bulk),
    cancelInvite(entities, invites, handleCancelInvites, bulk),
  ]

  if (invites.length && invitesCount === 1) {
    actions.unshift(copyInviteLink(invites[0], handleCopyInviteLink))
  }

  return actions
}
